(function () {
    'use strict';

    angular
        .module('app.campaign')
        .controller('LabelsModalController', LabelsModal);


    /*
     *
     * This function is injected three parameters from the controllers:
     * checkedCampaigns: an array of campaigns that are active and should be considered for the labeling
     * allLabelNames: all labels that should appear in the list
     * persistChanges: whether the changes should be saved in the database using the Label service as well
     * Note: parameters are injected and their modified values will be reflected back in the calling controller
     */
    LabelsModal.$inject = ['Label', 'checkedCampaigns', 'allLabelNames', 'persistChanges', 'close'];

    function LabelsModal(Label, checkedCampaigns, allLabelNames, persistChanges, close) {
        var vm = this;
        var originalLabels = [];

        vm.isSaveButtonDisabled = true;
        vm.labels = [];
        vm.states = ['', 'semi-checked', 'checked'];
        // result object that can be passed to the close callback
        vm.result = {};

        activate();

        function activate() {
            function lowerCase(string) {
                return string.toLowerCase();
            }

            var lowerCaseAllLabelNames = _.map(allLabelNames, lowerCase);

            angular.forEach(lowerCaseAllLabelNames, function (labelName) {
                var label = {};
                label.name = labelName;
                label.pids = [];
                angular.forEach(checkedCampaigns, function (campaign) {
                    var lowerCaseCheckedCampaignsLabelNames = _.map(_.pluck(campaign.labels, 'name'), lowerCase);
                    if (lowerCaseCheckedCampaignsLabelNames.indexOf(labelName.toLowerCase()) != -1) label.pids.push(campaign.pid);
                });
                if (label.pids.length == checkedCampaigns.length)
                    label.check = 2;
                else if (label.pids.length == 0)
                    label.check = 0;
                else
                    label.check = 1;
                originalLabels.push(label);
            });

            vm.labels = angular.copy(originalLabels);
        }


        vm.switchState = function (label) {
            vm.isSaveButtonDisabled = false;
            switch (label.check) {
                case 2:
                    label.check = 0;
                    break;
                case 1:
                    label.check = 2;
                    break;
                case 0:
                    var originalState = _.findWhere(originalLabels, {
                        name: label.name
                    }).check;
                    label.check = originalState == 1 ? 1 : 2;
            }
        };


        vm.createLabel = function (key) {
            if (key) {
                var targetPids = _.pluck(checkedCampaigns, 'pid');
                originalLabels.push({
                    'name': key,
                    'check': 0,
                    'pids': targetPids
                });
                vm.labels.push({
                    'name': key,
                    'check': 2,
                    'pids': targetPids
                });
                vm.isSaveButtonDisabled = false;
            }
        };

        vm.updateLabels = function () {
            angular.forEach(vm.labels, function (label, index) {
                var diff = label.check - originalLabels[index].check;
                if (diff > 0) {
                    addLabel(label);
                } else if (diff < 0) {
                    removeLabel(label);
                }
            });
            close(vm.result, 500); // close, but give 500ms for bootstrap to animate
        };

        function addLabel(label) {
            var toAdd = [];
            angular.forEach(checkedCampaigns, function (campaign) {
                var contains = _.some(campaign.labels, function (l) {
                    return angular.compICase(l.name, label.name);
                });

                if (!contains) {

                    if (!persistChanges) campaign.labels.push({name: label.name});
                    var allContains = _.some(allLabelNames, function (l) {
                        return angular.compICase(l, label.name);
                    });

                    if (!allContains) allLabelNames.push(label.name);

                    toAdd.push({
                        pid: campaign.pid,
                        name: label.name
                    });
                }
            });

            if (persistChanges) Label.addAll(toAdd, function (data) {
                angular.forEach(data, function (l) {
                    _.findWhere(checkedCampaigns, {
                        pid: l.pid
                    }).labels.push(l);
                    Notification.onLabelsChange();
                });
            });
        }

        function removeLabel(label) {
            var toDelete = [];
            angular.forEach(checkedCampaigns, function (campaign) {
                var ls = campaign.labels;
                angular.forEach(ls, function (l, i) {
                    if (angular.compICase(label.name, l.name)) {
                        ls.splice(i, 1);
                        toDelete.push({
                            pid: campaign.pid,
                            name: label.name
                        });
                    }
                });
            });

            if (persistChanges) Label.removeAll(toDelete, function(){
                Notification.onLabelsChange();
            });
        }
    }
})();